import React from 'react';
import PropTypes from 'prop-types';

import { AButton } from '../../atoms';
import { MInputField } from '../../molecules';

export default class OLogin extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			username: '',
			password: '',
			isValid: false,
		};

		this.bindHandles();
	}

	componentWillReceiveProps(props) {
		for (const key in this.state) {
			if (props[key] && props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		}
	}

	bindHandles() {
		this.handleOnLogin = this.handleOnLogin.bind(this);
		this.handleUserNameChange = this.handleUserNameChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
	}

	handleOnLogin() {
		if (!this.state.isValid) {
			return;
		}

		this.props.onLogin();
	}

	handleUserNameChange(username) {
		this.setState({ username, isValid: username && this.state.password });

		if (this.props.onUsernameChange) {
			this.props.onUsernameChange(username);
		}
	}
	handlePasswordChange(password) {
		this.setState({ password, isValid: password && this.state.username });

		if (this.props.onPasswordChange) {
			this.props.onPasswordChange(password);
		}
	}

	render() {
		return (
			<section className="o-login-cms">
				<h2>Login content manager</h2>
				<article>
					<MInputField
						id="idUsername"
						label="Gebruikersnaam"
						className="input-spacing"
						value={this.state.username}
						onChange={this.handleUserNameChange}
						required
					/>
					<MInputField
						id="idPassword"
						type="password"
						label="Wachtwoord"
						value={this.state.password}
						onChange={this.handlePasswordChange}
						required
					/>
				</article>
				<article className="o-login--buttons">
					<AButton
						value="ga naar de website"
						type="ghost"
						onClick={this.props.onBack}
					/>
					<AButton
						value="Login"
						onClick={this.handleOnLogin}
						disabled={!this.state.isValid}
					/>
				</article>
			</section>
		);
	}
}

OLogin.propTypes = {
	username: PropTypes.string,
	password: PropTypes.string,
	onUsernameChange: PropTypes.func,
	onPasswordChange: PropTypes.func,
	onLogin: PropTypes.func,
	onBack: PropTypes.func,
};

OLogin.defaultProps = {
	username: '',
	password: '',
	onUsernameChange: undefined,
	onPasswordChange: undefined,
	onLogin: undefined,
	onBack: undefined,
};




// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.login.js